import { useMemo } from 'react'
import { useRouteMatch } from 'react-router'

import { isCanvasFallbackRoute } from 'utils/route'
import { useShareViewsNavigation } from '../utils/shareViewsNavigation'

export const useIsCanvasFallback = () => {
  const { path } = useRouteMatch()
  const { previousView } = useShareViewsNavigation()

  return useMemo(
    () =>
      isCanvasFallbackRoute(path) || Boolean(previousView?.isCanvasFallback),
    [path, previousView?.isCanvasFallback]
  )
}
